/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../jquery.raty');
require('../base_jquery');
window.Vue = require('vue');
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
import StarRating from 'vue-star-rating';

import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
Vue.component('vue-simple-suggest', VueSimpleSuggest);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */



// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


Vue.component('star-rating', StarRating);

//Vue.component('vue-simple-suggest', VueSimpleSuggest);



let mobilepc = $("#case").data("mobilepc");
let category = $("#case").data("category");


if (mobilepc == 'pc') {
    Vue.component('review-component', require('../components/pc/ReviewComponent.vue').default);
    Vue.component('auto-comp-window-component', require('../components/pc/AutoCompleteWindowComponent.vue').default);
} else {
    Vue.component('review-component', require('../components/mobile/ReviewComponent.vue').default);
    Vue.component('auto-comp-window-component', require('../components/mobile/AutoCompleteWindowComponent.vue').default);


}




/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */





let lang = $("#case").data("lang");
const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'ja',
    messages: {
        'ja': require('../../lang/ja/review.json'),
        'en': require('../../lang/en/review.json'),
    }

});






const review = new Vue({
    el: '#review',
    i18n: i18n,
});


const auto_comp_window = new Vue({
    el: '#auto_comp_window',
    i18n: i18n,
});
